module.exports = __webpack_public_path__ + "static/media/GolfBkgSplash.fab05b0c.png";